import React from 'react';

import {
  BenefitEmployeePerkFilterFragment,
  BenefitWorkingCultureFilterFragment,
  CareerLevelFilterFragment,
  CityFilterFragment,
  CompanyFilterFragment,
  CountryFilterFragment,
  DisciplineFilterFragment,
  EmploymentTypeFilterFragment,
  IndustryFilterFragment,
  RemoteOptionFilterFragment,
} from '@/graphql/generated';

import { useSearchQuery } from '../../../contexts';

import * as S from '../query-tags.styles';

type Filter =
  | RemoteOptionFilterFragment
  | EmploymentTypeFilterFragment
  | CareerLevelFilterFragment
  | DisciplineFilterFragment
  | IndustryFilterFragment
  | BenefitEmployeePerkFilterFragment
  | BenefitWorkingCultureFilterFragment
  | CountryFilterFragment
  | CityFilterFragment
  | CompanyFilterFragment;

type Props = {
  filter: Filter;
  propertyName:
    | 'remoteOption'
    | 'employmentType'
    | 'careerLevel'
    | 'discipline'
    | 'industry'
    | 'benefitEmployeePerk'
    | 'benefitWorkingCulture'
    | 'country'
    | 'city';
  label: React.ReactNode;
};

export const QueryTagSet: React.FC<Props> = ({ filter, propertyName, label }) => {
  const paramName =
    propertyName === 'benefitWorkingCulture' || propertyName === 'benefitEmployeePerk' ? 'benefit' : propertyName;
  const {
    queryParams: [{ [paramName]: params }, setQueryParams],
  } = useSearchQuery();

  const onDelete = (): void => {
    params && setQueryParams({ [paramName]: params.filter((param) => param !== filter.entityId) });
  };

  // We instantly remove the filter param on delete (this will trigger a new X1 query)
  // In order to remove the tag immediately, we check for the existence of this param, so we don’t need to wait for the X1 response
  return params?.includes(filter.entityId) && filter?.[propertyName].localizationValue ? (
    <S.Tag variant="delete" onDelete={onDelete} data-cy={`search-query-tag-${propertyName}`}>
      {label}: {filter[propertyName].localizationValue}
    </S.Tag>
  ) : null;
};
